<template>
    <div class="panel-body">
        <div class="header" @click.prevent="showSection ? showSection = null : showSection = 'assignments'">
        	<h4>Assignments</h4>
        	<i class="fa fa-caret-down" v-if="showSection==='assignments'"></i>
            <i v-else class="fa fa-caret-right"></i>
        </div>
        <div v-if="showSection === 'assignments'" class="table-wrapper">
            <div v-if="assignments">
                <div v-for="(assignments, term) in assignments">
                    <h5>{{term}}</h5>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Course
                                </th>
                                <th>
                                    Week
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                            	    Path
                            	</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="assignment in assignments">
                                <td>
                                    <span v-if="assignment.instance">
                                        {{assignment.instance.associated.name}}
                                    </span>
                                </td>
                                <td>Week {{assignment.week}}</td>
                                <td>{{assignment.name}}</td>
                                <td><span v-if="assignment.instance">{{assignment.instance.path}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="header" @click.prevent="showSection ? showSection = null : showSection = 'exercises'">
        	<h4>Exercises</h4>
        	<i class="fa fa-caret-down" v-if="showSection==='exercises'"></i>
            <i v-else class="fa fa-caret-right"></i>
        </div>
        <div v-if="showSection === 'exercises'" class="table-wrapper">
            <div v-if="exercises">
                <div v-for="(exercises, term) in exercises">
                    <h5>{{term}}</h5>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Course
                                </th>
                                <th>
                                    Week
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                	Path
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="exercise in exercises">
                                <td>
                                    <span v-if="exercise.video && exercise.video.course_instance">
                                        {{exercise.video.course.name}}
                                    </span>
                                </td>
                                <td>Week {{exercise.video.week}}</td>
                                <td>{{exercise.title}}</td>
                                <td>{{exercise.path}}</td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import files from '../../services/files';
import _ from 'lodash';

export default {
    data() {
        return {
            assignments: null,
            exercises: null,
            showSection: null
        }
    },
    components: {

    },
    created() {
        files.getWatermarkedFiles().then((response) => {

            let assignments = _.groupBy(response.data.assignments, (a) => {
                if (a.instance) {
                    return a.instance.associated_term.name
                }
            });


            this.assignments = assignments;

			let exercises = _.groupBy(response.data.exercises, (e) => {
            	if (e.video && e.video.course_instance) {    	
                    return e.video.course_instance.associated_term.name
                }
            });

			this.exercises = exercises;      
        });
    },
    mounted() {

    },
    methods: {

    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>
h4,
.table-wrapper {
    padding: 0 2rem;
}

.header {
	display:flex;
	align-items:center;
	margin-bottom:3rem;
	cursor:pointer;
}

h4 {
	
}
table {
    table-layout: fixed;
    width:100%;
}

td,
th {
    padding: 1rem;
}

</style>



// WEBPACK FOOTER //
// WatermarkedFiles.vue?57b97e22